module.exports = "../dist/img/product-card-21.3e52.jpg";